<template>
  <div>
    <Navbar v-show="routemeta.navbar" />
    <Breadcrumb :label="course_name" v-show="routemeta.navbar" />
    <div class="container-xl">
      <div class="border-0 text-container-wider">
        <b-card-title>
          <h2 class="text-primary">
            {{ course_name }}
          </h2>
        </b-card-title>
        <b-card-body class="mx-0 px-0 col-12">
          <b-row class="mx-0 px-0">
            <div class="mx-0 px-0 col-xs-12 col-7">
              <span v-html="course_introduction"></span>
              <br>
              Language: {{ course_language }}
            </div>
            <div class="mx-0 px-0 col-xs-12 col-5 text-right text-top">
              <b-button href="/learninghub" class="mr-2">Learning Hub</b-button>
              <b-button>Contact your tutor</b-button>
            </div>
          </b-row>
          <h3
            class="pt-4 mt-4"
            style="border-top: 1px solid black"
          >
            Modules
          </h3>
          <b-table
            class="mx-0 px-0 mb-4"
            :busy="loading"
            :items="modules"
            :fields="moduleColumns"
          >
            <template #table-busy>
              <div class="text-center text-success my-2">
              <b-spinner class="align-middle mr-2" />
              <strong>Loading...</strong>
              </div>
            </template>
            <template
              v-slot:cell(module_number)="data"
            >
              <span :class="data.item.module_number > last_finished_module_number + 1 ? 'text-muted': ''">
                {{ data.item.module_number }} {{ data.item.last_finished_module_number }}
              </span>
            </template>
            <template
              v-slot:cell(module_name)="data"
            >
              <span :class="data.item.module_number > last_finished_module_number + 1 ? 'text-muted': ''">
                {{ data.item.module_name }}
              </span>
            </template>
            <template
              v-slot:cell(steps)="data"
            >
              <span :class="data.item.module_number > last_finished_module_number + 1 ? 'd-none': ''">
                {{ data.item.steps }}
              </span>
            </template>
            <template
              v-slot:cell(status)="data"
            >
              <span v-if="data.item.exam_id == 0" :class="data.item.module_number > last_finished_module_number + 1 ? 'text-muted': ''">
                {{ data.item.status == 'NOTSTARTED' ? 'Not started' : data.item.status == 'STEPSDONE' ? 'Completed' : 'In progress' }}
              </span>

              <span  v-if="data.item.exam_id !=0 " :class="data.item.module_number > last_finished_module_number + 1 ? 'text-muted': ''">
                {{ data.item.examstatus == 'PASSED' ? 'Passed' : data.item.examstatus == 'NOTSTARTED' ? 'Not started' : 'Under review' }}
              </span>
            </template>
            <template v-slot:cell(actions)="data">
              <b-dropdown right class="w-100">
                <template #button-content>
                  <i class="fa-solid fa-ellipsis"></i>
                </template>
                <b-dropdown-item
                  v-show="data.item.module_number <= last_finished_module_number + 1 && data.item.status == 'NOTSTARTED'"
                >
                  <b-link
                    :to="`/elearningmodule/${data.item.id}`"
                  >
                    Start
                  </b-link>
                </b-dropdown-item>
                <b-dropdown-item
                  v-show="data.item.module_number <= last_finished_module_number + 1 && data.item.status == 'STARTED' && data.item.examstatus != 'FAILED'"
                >
                  <b-link
                    :to="`/elearningmodule/${data.item.id}`"
                  >
                    Continue
                  </b-link>
                </b-dropdown-item>
                <b-dropdown-item
                  v-show="data.item.status == 'STEPSDONE' || data.item.examstatus == 'PASSED'"
                >
                  <b-link
                    :to="`/elearningmodule/${data.item.id}`"
                      class="mr-2"
                  >
                    View
                  </b-link>
                </b-dropdown-item>

              </b-dropdown>
            </template>
          </b-table>
          <div
            v-if="materials.length > 0"
          >
            <h3
              class="pt-4 mt-4"
              style="border-top: 1px solid black"
            >
              Materials
            </h3>
            <b-table
              id="materials"
              ref="materials"
              hover
              class="col-12 mx-0 px-0 mb-4"
              :items="materials"
              :fields="materialfields"
              @row-clicked="material_show"
              :per-page="materialsPerPage"
            >
              <template v-slot:cell(material_heading)="data">
                <span class="pt-0">
                <fa-icon
                  v-if="data.item.material_extension=='doc'||data.item.material_extension=='docx'"
                  name="file-word"
                />
                <fa-icon
                  v-if="data.item.material_extension=='xls'||data.item.material_extension=='xlsx'"
                  name="file-excel"
                />
                <fa-icon
                  v-if="data.item.material_extension=='ppt'||data.item.material_extension=='pptx'"
                  name="file-powerpoint"
                />
                <fa-icon
                  v-if="data.item.material_extension=='pdf'"
                  name="file-pdf"
                />
                </span>
                <span class="pt-4 ml-2">{{ data.item.material_heading }}</span>
              </template>
              <template v-slot:cell(actions)="data">
                <b-dropdown right class="w-100">
                  <template #button-content>
                    <i class="fa-solid fa-ellipsis"></i>
                  </template>
                  <b-dropdown-item>
                    <b-link
                      @click="material_show(data.item.id)"
                    >
                      View
                    </b-link>
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
            <b-link
              v-show="materials.length > 5 && materialsPerPage == 5"
              @click="toggleShowMaterials"
            >
              Show all
            </b-link>
          </div>
          <div
            v-if="coursenotes.length > 0"
          >
            <h3
              class="pt-4 mt-4"
              style="border-top: 1px solid black"
            >
              My notes
            </h3>
            <b-table
              id="notes"
              ref="notes"
              hover
              class="col-12 mx-0 px-0 mb-4"
              :items="coursenotes"
              :fields="notesfields"
            >
              <template v-slot:cell(actions)="data">
                <b-dropdown right class="w-100">
                  <template #button-content>
                    <i class="fa-solid fa-ellipsis"></i>
                  </template>
                  <b-dropdown-item>
                    <b-link
                      :href="`/elearningstep/${data.item.step_id}`"
                    >
                      View
                    </b-link>
                  </b-dropdown-item>
                  <b-dropdown-item>
                    <b-link
                      href="#"
                      @click.prevent="downloadStepNote(data.item.step_note, data.item.step_id)"
                    >
                      Download
                    </b-link>
                  </b-dropdown-item>
                </b-dropdown>
              </template>
              <template v-slot:cell(step_note)="data">
                {{ data.item.step_note }}
              </template>
            </b-table>
            <b-link
              v-show="coursenotes.length > 5 && notesPerPage == 5"
              @click="toggleShowNotes"
            >
              Show all
            </b-link>
          </div>
          <h3
            class="pt-4 mt-4"
            style="border-top: 1px solid black"
          >
            Exams
          </h3>
        </b-card-body>
      </div>
    </div>
  </div>
</template>
<script>
import Navbar from './Navbar.vue'
import Breadcrumb from './Breadcrumb.vue'
import { config } from '../../config'

const moduleColumns = [
  { key: 'module_number', label: '#', thClass: 'd-xs-none col-1 gdq-w-10', sortable: true },
  { key: 'module_name', label: 'Name', thClass: 'col-7', sortable: true },
  { key: 'status', thClass: 'col-1', sortable: true },
  { key: 'teacher_name', label: 'Teacher', thClass: 'col-2', sortable: false },
  { key: 'steps', label: 'Steps', thClass: 'col-1', sortable: false },
  { key: 'actions', label: 'Actions', class: 'ellipsis-button' }
]

const materialfields = [
  { key: 'material_heading', label: 'Document', sortable: false },
  { key: 'material_module_name', label: 'Module', sortable: true },
  { key: 'actions', label: 'Actions', class: 'ellipsis-button' }
]

const notesfields = [
  { key: 'module_number', label: 'Module', sortable: true, tdClass: 'col-1' },
  { key: 'step_note', label: 'Notes', sortable: false, tdClass: 'col-9 gdq-note-cell' },
  { key: 'actions', label: 'Actions', class: 'ellipsis-button' }
]

export default {
  name: 'LearningCourse',
  components: {
    Navbar,
    Breadcrumb
  },
  data () {
    return {
      routemeta: this.$route.meta,
      consultant_id: this.$store.state.user_id,
      course_id: this.$route.params.c ? this.$route.params.c : 0,
      course_name: '',
      course_introduction: '',
      course_language: '',
      exam_after_module: 0,
      course_exam_id: 0,
      modules: [],
      moduleColumns: moduleColumns,
      module_id: 0,
      last_finished_module_number: 0,
      step_number: this.$route.params.s ? this.$route.params.s : 0,
      materials: [],
      materialfields: materialfields,
      materialsPerPage: 5,
      coursenotes: [],
      notesfields: notesfields,
      notesPerPage: 5,
      popshow_id: 0,
      loading: true
    }
  },
  created () {
    this.course_get()
  },
  methods: {
    downloadStepNote (stepNote, stepId) {
      const blob = new Blob([stepNote], { type: 'text/plain' })
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = `StepNote-${stepId}.txt` // Customize the file name as needed
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    note_show () {
      console.log('note_show')
    },
    toggleShowNotes () {
      this.notesPerPage = this.notesPerPage === 5 ? this.coursenotes.length : 5
    },
    toggleShowMaterials () {
      this.materialsPerPage = this.materialsPerPage === 5 ? this.materials.length : 5
    },
    async coursenotes_get () {
      const stepfilter = {
        module_id: {
          operator: 'IN',
          value: this.modules.map(function (e) { return e.id }).toString()
        }
      }
      const stepsResponse = await this.$store.dispatch('records_readall', { table_name: 'g_elearning_steps', filter: stepfilter })
      const steps = stepsResponse.data.result
      let outSteps = []
      for (let i = 0; i < steps.length; i++) {
        outSteps.push(steps[i].id)
      }
      const filter = {
        consultant_id: {
          operator: '=',
          value: this.consultant_id
        },
        step_id: {
          operator: 'IN',
          value: outSteps.toString()
        }
      }
      const coursenotesResponse = await this.$store.dispatch('records_readall', { table_name: 'g_elearning_consultant_notes', filter: filter })
      const coursenotes = coursenotesResponse.data.result
      for (let i = 0; i < coursenotes.length; i++) {
        const module_id = steps.filter(s => s.id === coursenotes[i].step_id)[0].module_id
        const thismodule = await this.$store.dispatch('record_read', { table_name: 'g_elearning_modules', id: module_id }).then(m => m.data)
        coursenotes[i].module_number = thismodule.module_number
      }
      this.coursenotes = coursenotes
    },
    async materials_get () {
      this.$store.dispatch('records_readall', { table_name: 'g_elearning_modules_materials' })
        .then(async (resp) => {
          const x = resp.data.result
          let materials = new Array()
          for (let i = 0; i < x.length; i++) {
            const module = await this.$store.dispatch('record_read', { table_name: 'g_elearning_modules', id: x[i].g_elearning_modules })
            if (module.data.course_id != this.course_id) {
              continue
            }
            const material = {
              material_id: x[i].g_elearning_materials,
              module_name: module.data.module_name,
              module_number: module.data.module_number
            }
            materials.push(material)
          }
          const filter = {
            id: {
              operator: 'IN',
              value: materials.map(m => m.material_id).toString()
            }
          }
          this.$store.dispatch('records_readall', { table_name: 'g_elearning_materials', filter: filter, orderby: 'material_heading' })
            .then((resp) => {
              this.materials = []
              var item
              var ext
              for (var i = 0; i < resp.data.result.length; i++) {
                item = resp.data.result[i]
                const material_module_number = materials.filter(m => m.material_id === item.id)[0].module_number
                const material_module_name = materials.filter(m => m.material_id === item.id)[0].module_name

                ext = item.material_extension.toLowerCase()
                var result = {
                  id: item.id,
                  material_heading: item.material_heading,
                  material_module_number: material_module_number,
                  material_module_name: `${material_module_number} ${material_module_name}`,
                  material_extension: ext
                }
                this.materials.push(result)
              }
            })
        })
    },
    material_show (item) {
      var reporturl = config.report_url + '/gdq_elearning_materials.php?r=' + item.id
      var downloadURL = new URL(reporturl)
      var downloadLink = document.createElement('a')
      downloadLink.href = downloadURL
      downloadLink.setAttribute('download', 'GDQ_Elearning_Material_' + item.id + '.' + item.material_extension)
      document.body.appendChild(downloadLink)
      downloadLink.click()
    },
    async course_get () {
      const resp = await this.$store.dispatch('record_read', { table_name: 'g_elearning_courses', id: this.course_id })
      this.course_name = resp.data.course_name
      this.course_introduction = resp.data.course_introduction
      this.exam_after_module = resp.data.exam_after_module
      await this.modules_get()
      await this.language_get(resp.data.course_language)
      await this.materials_get()
      await this.coursenotes_get()
      this.loading = false
    },
    async language_get (language_id) {
      return await this.$store.dispatch('record_read', { table_name: 'g_languages', id: language_id }).then(r => this.course_language = r.data.language_name)
    },
    async modules_get () {
      let modules = await this.$store.dispatch('elearning_consultant_course_getmodules', { consultant_id: this.consultant_id, course_id: this.course_id })
      modules = modules.data.result
      let outmodules = []
      for (let i = 0; i < modules.length; i++) {
        if (modules[i].status == 'STEPSDONE' && modules[i].module_number > this.last_finished_module_number) {
          this.last_finished_module_number = parseInt(modules[i].module_number)
        }
        modules[i].steps = `${modules[i].steps_done}/${modules[i].number_steps}`
        if (modules[i].exam_id == '1') {
          let examstatus = await this.$store.dispatch(
            'elearning_exam_check',
            {
              consultant_id: this.consultant_id,
              module_id: modules[i].id,
              exam_id: modules[i].exam_id
            }
          )
          examstatus = examstatus.data
          console.log(examstatus)
          modules[i].module_name = modules[i].exam_title
          modules[i].examstatus = examstatus.number_questions == examstatus.number_correct ? 'PASSED' : examstatus.number_questions == 0 ? 'NOTSTARTED' : 'FAILED'
          if (modules[i].examstatus == 'FAILED') {
            modules[i].status = 'STARTED'
          }
        } else {
          modules[i].examstatus = 'NOEXAM'
        }
        outmodules.push(modules[i])
      }
      this.modules = outmodules
    },
    module_set (module) {
      if (module.module_number === -1) {
        return false
      }
      if (module.module_number <= (this.last_finished_module_number + 1)) {
        this.$router.push({ path: '/elearningmodule/' + module.id })
      }
    },
    exam_set () {
      this.$router.push('/elearningexam/' + this.course_id)
    },
    gohome () {
      this.$router.push({ path: '/learninghub/' })
    },
    next_step () {
      this.step_number += 1
    }
  }
}
</script>
<style>
.gdq-note-cell {
  max-width: 100px !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
}
@media (min-width: 240px) {
  .gdq-note-cell {
    max-width: 180px !important; /* Adjust as needed */
  }
}
@media (min-width: 480px) {
  .gdq-note-cell {
    max-width: 260px !important; /* Adjust as needed */
  }
}
@media (min-width: 576px) {
  .gdq-note-cell {
    max-width: 380px !important; /* Adjust as needed */
  }
}
@media (min-width: 768px) {
  .gdq-note-cell {
    max-width: 560px !important; /* Adjust as needed */
  }
}

/* Even larger devices (e.g., large desktops) */
@media (min-width: 1200px) {
  .gdq-note-cell {
    max-width: 960px !important; /* Adjust as needed */
  }
}
td {
  cursor: pointer !important;
}
</style>
